import PropTypes from 'prop-types';

import { IconContext } from 'react-icons';
// import * as HiIcons from 'react-icons/hi';
import * as FaIcons from 'react-icons/fa';
// import * as MdIcons from 'react-icons/md';
// import * as GiIcons from 'react-icons/gi';
// import * as Fa6Icons from 'react-icons/fa6';
const DynamicIcon = ({ name, size, color }) => {
    const IconComponent = FaIcons[name];
    // if (!IconComponent) {
    //     IconComponent = HiIcons[name];
    // }
    // if (!IconComponent) {
    //     IconComponent = MdIcons[name];
    // }
    // if (!IconComponent) {
    //     IconComponent = GiIcons[name];
    // }
    // if (!IconComponent) {
    //     IconComponent = Fa6Icons[name];
    // }
    if (!IconComponent) {
        return <FaIcons.FaAccusoft size={size} />;
    }

    return (
        <IconContext.Provider value={{ color }}>
            <IconComponent size={size} />
        </IconContext.Provider>
    );
};

DynamicIcon.propTypes = {
    color: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number,
};

export default DynamicIcon;
